import { Pipe, PipeTransform } from '@angular/core';
import DateUtils from '@shared/utils/date-utils';

@Pipe({ name: 'keepZoneDateTime' })
export class KeepZoneDateTimePipe implements PipeTransform {

  transform(val: any): any {
    return DateUtils.keepTimezoneDateTime(val);
  }

}
